import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { ReportsService } from '../../services/reports.service';
import {
  FilterGroupType,
  PredefinedFiltersService,
  ServerFilterGroup,
} from 'src/app/services/predefined-filters.service';
import { Subscription } from 'rxjs';

interface UiFilter {
  name: string;
  value: string;
  isSelected: boolean;
}

interface UiFilterGroup {
  name: string;
  canSelectMultipleValues: boolean;
  someSelected: boolean;
  allSelected: boolean;
  filters: UiFilter[];
}

@Component({
  selector: 'vrm-filter-selection-dialog',
  templateUrl: './filter-selection.component.html',
  styleUrls: ['./filter-selection.component.scss'],
})
export class FilterSelectionDialogComponent implements OnInit, OnDestroy {
  public filterGroups: UiFilterGroup[] = [];
  private filterSubscription: Subscription;

  constructor(
    public cService: CommonService,
    public rptService: ReportsService,
    private predefinedFiltersService: PredefinedFiltersService
  ) {}

  ngOnInit() {
    this.filterSubscription = this.predefinedFiltersService.getGroupedFilters().subscribe({
      next: (filterGroups: ServerFilterGroup[]) => {
        this.filterGroups = this.transformFiltersToCheckboxes(filterGroups);
      },
    });
  }

  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  public updateGroupState(filterGroup: UiFilterGroup): void {
    filterGroup.allSelected = filterGroup.filters.every((filter) => filter.isSelected);
    filterGroup.someSelected = filterGroup.filters.some((filter) => filter.isSelected) && !filterGroup.allSelected;
  }

  public selectAllFiltersForGroup(checkState: boolean, filterGroup: UiFilterGroup): void {
    filterGroup.filters.forEach((filter) => (filter.isSelected = checkState));
    this.updateGroupState(filterGroup);
  }

  public selectRadioFilter(selectedFilter: UiFilter, filterGroup: UiFilterGroup): void {
    filterGroup.filters.forEach((filter) => (filter.isSelected = filter.value === selectedFilter.value));
    this.updateGroupState(filterGroup);
  }

  public applySelectedFilters(): void {
    const allFilters = [].concat.apply(
      [],
      this.filterGroups.map((filterGroup) => filterGroup.filters)
    );
    const selectedFilters = allFilters.filter((filter: UiFilter) => filter.isSelected);
    const unSelectedFilters = allFilters.filter((filter: UiFilter) => !filter.isSelected);

    this.predefinedFiltersService.enableFilters(selectedFilters.map((filter: UiFilter) => filter.value));
    this.predefinedFiltersService.disableFilters(unSelectedFilters.map((filter: UiFilter) => filter.value));
  }

  private transformFiltersToCheckboxes(filterGroups: ServerFilterGroup[]): UiFilterGroup[] {
    return filterGroups.map((filterGroup) => {
      return {
        name: filterGroup.name,
        canSelectMultipleValues: filterGroup.type === FilterGroupType.Multiple,
        someSelected: filterGroup.filters.some((filter) => filter.isActive),
        allSelected: filterGroup.filters.every((filter) => filter.isActive),
        filters: filterGroup.filters.map((filter) => {
          return {
            name: filter.name,
            value: filter.value,
            isSelected: filter.isActive,
          };
        }),
      };
    });
  }
}
